/* eslint-disable */
import React from "react";
import { componentID } from "core/services/componentService/component-service-base";
import BaseSimpleSourceAI from "./source-configurator/pages/source-form-config/base-simple-source/base-simple-source-ai";
import { buildCancelledResponse } from "../utils/hitl-cancel";

export interface ShowSimpleWizardFormToolProps {
    args: { componentName: string; appName: string; templateID?: string };
    respond?: (result: string) => void;
}

export const ShowSimpleWizardFormTool: React.FC<ShowSimpleWizardFormToolProps> = ({ args, respond }) => {
    const handleSave = (data: Record<string, any>) => {
        respond?.(JSON.stringify({ status: "saved", properties: data }));
    };

    const handleCancel = () => respond?.(buildCancelledResponse());

    return (
        <BaseSimpleSourceAI
            componentID={args.componentName as componentID}
            appName={args.appName}
            templateID={args.templateID}
            onSave={handleSave}
            onCancel={handleCancel}
        />
    );
};
